import PDFObject from './PDFObject.js';
import CharCodes from '../syntax/CharCodes.js';
import { PDFClasses } from '../../api/objects.js';
class PDFNull extends PDFObject {
    myClass() {
        return PDFClasses.PDFNull;
    }
    asNull() {
        return null;
    }
    clone() {
        return this;
    }
    toString() {
        return 'null';
    }
    sizeInBytes() {
        return 4;
    }
    copyBytesInto(buffer, offset) {
        buffer[offset++] = CharCodes.n;
        buffer[offset++] = CharCodes.u;
        buffer[offset++] = CharCodes.l;
        buffer[offset++] = CharCodes.l;
        return 4;
    }
}
PDFNull.className = () => PDFClasses.PDFNull;
export default new PDFNull();
//# sourceMappingURL=PDFNull.js.map